<template>
  <div class="semiconductor">
    <s-r-m-header ref="header" />
    <IndustryDesc ref="industryDesc" :industryInfo="industryInfo" show-menu />
    <ProjectDesc
      :descInfo="{
        title: '半导体行业特征',
        description: '璞华易研PLM提供适用于芯片半导体行业的研发管理平台',
        redContent: '半导体行业',
        content: '产业链涉及多个环节，从原材料和设备的生产到最终产品的制造。这个产业链的核心是半导体制造，它包括晶圆制造、芯片设计和制造、封装和测试等环节。其中，晶圆制造是整个产业链的基础，它负责生产半导体所需的晶圆。在晶圆制造完成后，芯片设计公司根据需求设计芯片，然后将设计好的芯片交给晶圆厂进行制造。制造完成后，芯片被送到封装厂进行封装，以保护芯片免受损坏并提高芯片的整体性能。最后，封装好的芯片被送到测试厂进行测试，以确保芯片的性能和稳定性。除了这些核心环节外，半导体行业产业链还包括设备制造、材料供应、软件和电子设计自动化（EDA）工具的开发等重要组成部分。',
        img: bdtmb
      }"
    ></ProjectDesc>
    <ProblemSolving></ProblemSolving>

    <ValueGain
      title="璞华易研PLM在半导体行业的优势"
      description="根据对众多客户调查研究的结果，璞华易研PLM通常能为企业带来以下价值收益"
      :caseList="caseList"
    ></ValueGain>
    
    <!-- <product-features
      title="产品功能"
      description="PLM产品生命周期管理产品数据管理、项目协同管理、研发管理、设计工具集成"
      :tabList="tabList"
    ></product-features> -->
    <SystemFunction
      :systemInfo="systemInfo"
    ></SystemFunction> 
    <!-- <CompanyInfo
      :projectInfo="projectInfo"
    ></CompanyInfo> -->
  
    <!-- <ResultsOperation
      :descInfo="{
        title: '项目的实施效果',
        descArr1: [
          '建立统一的产品数据管理平台，实现公司数据的标准化管理，包括分类、编码、属性等从而减少数据混乱；',
          '产品数据权限管控，满足对半导体研发的保密性要求；',
          '项目管理包含产品研发过程所有任务及交付物的整合，在系统中完成项目任务分解，任务分派自动通知各工程师，即时评审交付件；'
        ],
        descArr2: [
          '签核流程电子化，并实现审核人自动匹配，减少人为添加审核人和推关的工作；',
          'PLM数据发行自动传送到ERP、MES，研发数据准确及时给生产和采购等，提高数据在各IT系统中规范性和正确性。',
        ]
      }"
    ></ResultsOperation> -->
    <ChooseUs :nameVals="['semiconductor']"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box /> 
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import IndustryDesc from "@/components/IndustryDesc"
import ProblemSolving from "@/components/ProblemSolving"
import ProjectDesc from "@/components/ProjectDesc"
import LifeCycle from "@/components/LifeCycle"
import ValueGain from "@/components/ValueGain"
import ChooseUs from "@/components/ChooseUs"

import AppBenefits from "@/components/AppBenefits"
import ProductFeatures from "@/components/ProductFeatures"
import CompanyInfo from "@/components/CompanyInfo"
import ResultsOperation from "@/components/ResultsOperation"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import SystemFunction from "@/components/SystemFunction"
import { baiduConsult } from "./common.js";

import hy4 from '@/assets/images/hy4.png'
import jjfa1 from '@/assets/images/jjfa1.png'
import jjfa2 from '@/assets/images/jjfa2.png'


export default {
  components: {
    SRMHeader,
    IndustryDesc,
    ProblemSolving,
    ProjectDesc,
    LifeCycle,
    ValueGain,
    SystemFunction,

    AppBenefits,
    ProductFeatures,
    CompanyInfo,
    ResultsOperation,
    ChooseUs,
    CustomForm,
    FooterBox,
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      systemInfo: {
        title: '解决方案',
        description: '帮助客户建立统一的产品数据管理平台，规范产品数据管理',
        img: jjfa1,
        img2: jjfa2,
      },
      bdtmb: require('@/assets/images/bdtmb.png'),
      caseList: [
        {
          img: require('@/assets/images/sy2-1.png'),
          num: '01',
          descArr: ['追踪从需求立项到', '量产制造完整的产', '品开发过程']
        },
        {
          img: require('@/assets/images/sy2-2.png'),
          num: '02',
          descArr: ['建立BOI产品数据', '信息知识库']
        },
        {
          img: require('@/assets/images/sy2-3.png'),
          num: '03',
          descArr: ['提升产品和体系', '质量满足客户验厂', '（三化一稳定）', '要求']
        },
        {
          img: require('@/assets/images/sy2-4.png'),
          num: '04',
          descArr: ['提高产品设计、开', '发和工艺变更效率']
        }
      ],
      listData: [
        {
          num: '01',
          description: '建立符合医疗设备行业QMS体系的合规数据集（含DHF、DMR、R/A docs、Risk Management、Change Managemgmt 、CAPA',
        },
        {
          num: '02',
          description: '建立符合医疗设备行业QMS体系的产品开发项目管理体系，对设备研发过程、资源、交付物及过程质量进行管理',
        },
        {
          num: '03',
          description: '建立协同的技术评审及产品资料电子化审签流程，对资料的创建、审批及发布进行管理',
        },
        {
          num: '04',
          description: '建立产品全过程闭环质量管理体系，对研发过程质量、缺陷、生产过程质量、客户投诉等进行统一管理',
        }
      ],
      industryInfo: {
        bg: hy4,
        // text1: '璞华易研PLM可帮助半导体公司管理遍布全球的团队和',
        text2: '璞华易研PLM为半导体IC企业提供全方位的解决方案'
      },
      projectInfo: {
        companyName: '某芯片半导体研发公司',
        description: '帮助客户建立统一的产品数据管理平台，规范产品数据管理',
        paragraph: [
          '该公司是一家从事新型半导体材料设计、研发及封装加工的国家高新技术企业。公司致力于高速光通信VCSEL芯片、高功率密度激光雷达VCSEL芯片、高效率3D感测VCSEL芯片以及新型LED封装产品的研发、生产和销售，全面赋能数据中心光互连、汽车自动驾驶与智能座舱、消费电子及工业应用的传感与智慧照明等领域，为行业客户提供领先的光解决方案。'
        ],
        caseList: [
          {
            num: '01',
            title: '物料/BOM管理',
            contentList: [
              '规范物料分类、编码、属性、生命周期与版本管理；',
              '规范产品BOM搭建，基于研发和设计的结果于系统上建立正确的物料及BOM信息,快速有效移转为生产所需完整信息并集中管理。',
            ]
          },
          {
            num: '02',
            title: '文档管理',
            contentList: [
              '规范文档分类、编码、属性、生命周期与版本管理；',
              '实现工艺程序文件管理。',
            ]
          },
          {
            num: '03',
            title: '变更管理',
            contentList: [
              '按需定义变更分类管理，定义ECR、ECO、ECN等流程，规范流程，提高部门运转效率；',
              '详细记录每次改动变化，版本与生命周期的变化，并可追查历史记录与资料。'
            ]
          },
          {
            num: '04',
            title: '项目管理',
            contentList: [
              '支撑公司规范、统一、标准化的研发和工程体系建设；',
              '加强新产品开发及项目计划、进度的实时控制与管理；',
              '平衡研发资源的配置，提高项目开发效率；',
              '通过项目敏捷管理，降低产品开发成本和工程交付周期。'
            ]
          }
        ]
      },
      tabList: [
        {
          name: 'first',
          label: '数据管理',
          title: '以数据为核心',
          otherTitle: '将数据管理贯穿产品的全生命周期',
          effectDrawing: require('@/assets/images/gn1.png'),
          contentList: [
            {
              title: '物料管理',
              content: '物料编码规则、物料属性定义、物料的生命周期管理、物料分类定义'
            },
            {
              title: 'bom管理',
              content: 'bom结构、替代料管理、bom正反结构查询'
            },
            {
              title: '制造商管理',
              content: '制造商管理、制造商部件号管理'
            },
            {
              title: '文档管理',
              content: '文档分类、文档版本、文档权限等管理'
            }
          ]
        },
        {
          name: 'second',
          label: '变更管理',
          title: '根据用户的个性化需求，支持用户定义各种规则，对变更进行',
          otherTitle: '跟踪和管理',
          effectDrawing: require('@/assets/images/gn2.png'),
          contentList: [
            {
              content: '内置了行业标准的ECR-ECO的工程变更解决方案'
            },
            {
              content: '可以根据客户的个性化需求进行业务流程配置'
            },
            {
              content: '提供了行业领先的用户可编程引擎，支持用户定义各种规则'
            }
          ]
        },
        {
          name: 'third',
          label: '项目管理',
          title: '项目计划＆项目进度＆项目交付＆项目报表',
          effectDrawing: require('@/assets/images/gn3.png'),
          contentList: [
            {
              content: '采用最新的BS技术实现项目中的各种管理功能'
            },
            {
              content: '包含项目计划、交付、资源、工时、费用、报表等核心功能'
            },
            {
              content: '帮助企业实现项目集的管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'four',
          label: '数据建模',
          title: '通过数据建模，支持客户的个性化需求',
          effectDrawing: require('@/assets/images/gn4.png'),
          contentList: [
            {
              content: '提供强大的配置平台，支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限'
            },
            {
              content: '实现完全可配置的业务，支持数据、流程、字段级别的数据建模和精细化的权限控制'
            }
          ]
        },
        {
          name: 'five',
          label: '在线可视化',
          title: '目前支持超过40多种主流的文件格式在线预览，所见即所得',
          effectDrawing: require('@/assets/images/gn5.png'),
          contentList: [
            {
              content: '采用最新的BS架构实现了文件的预览，不需要用户客户端安装任何的客户端软件'
            },
            {
              content: '支持主流2D文件(Office、CAD、压缩文件、文本文件、图片、音频)格式的预览'
            },
            {
              content: '支持主流3D文件(prt、asm、pcb、stp) 格式的预览'
            }
          ]
        },
        {
          name: 'six',
          label: '第三方接入',
          title: '轻松实现与第三方软件的对接',
          effectDrawing: require('@/assets/images/gn6.png'),
          contentList: [
            {
              content: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成'
            },
            {
              content: '自带主流的ERP集成接口和移动端集成，支持数据导出'
            }
          ]

        }
      ]
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.semiconductor {
  ::v-deep .project-desc {
    .project-content {
      width: 140rem;
    }
  }
  ::v-deep .industry-desc {
    .text-content {
      .text2 {
        font-size: 5rem !important;
        margin-top: 4rem;
      }
    }
  }
  ::v-deep .company-info {
    .content-top {
      height: 46rem;
    }
    .project-bg {
      height: 30rem;
    
      .paragraph {
        margin-top: 3.6rem;
      }
    }
  }
  ::v-deep .systemFunction-container {
    background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  .typical-user {
    ::v-deep .systemFunction-list {
      height: 55.2rem;
    }
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
